<app-wheel-selector
  [title]="titlePrefix"
  [homeTeamName]="homeTeamName"
  [awayTeamName]="awayTeamName"
  [homeHasPossession]="homeHasPossession"
  [data]="data"
  [disabled]="disabled"
  #wheelSelector
  (changeValue)="change($event)">
</app-wheel-selector>
